import React, { useEffect } from 'react'
import '../solar-style.scss'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton'
import CompanyLogo from '../../../assets/images/electric-pole.png'
import SolarPanel from '../../../assets/images/solar-panel.png'
import Lighting from '../../../assets/images/lighting.png'
import Towerg from '../../../assets/images/power-tower-g.png'
import Towery from '../../../assets/images/power-tower -y.png'
import Towerred from '../../../assets/images/cancel (1) 2.svg'
import Gridorange from '../../../assets/images/DS1.svg'
import Gridored from '../../../assets/images/DS3.svg'
import Medical from '../../../assets/images/medical.png'
import Multimeter from '../../../assets/images/multimeter.png'
import Pyranometer from '../../../assets/images/pyranometer.png'
import Accumulatordas from '../../../assets/images/accumulatordas.png'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import TablePagination from '@mui/material/TablePagination'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@mui/material/InputAdornment'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import BugReportIcon from '@mui/icons-material/BugReport'
import CircularProgress from '@mui/material/CircularProgress'
import useSolarPlantListStyles from '../styles.js'
import dayjs from 'dayjs'

// Helper functions (kept as they are utility-like)
const getDeviceInfoFromRoof = (roofDetails, deviceType) => {
    if (!roofDetails || roofDetails.length === 0) return { make: '-', model: '-', count: 0 }
    let devices = []
    roofDetails.forEach((roof) => {
        if (roof?.[deviceType]) devices = [...devices, ...roof[deviceType]]
    })
    if (devices.length === 0) return { make: '-', model: '-', count: 0 }
    const firstDevice = devices[0]
    return { make: firstDevice?.make || '-', model: firstDevice?.model || '-', count: devices.length }
}

const renderDeviceStatusIcon = (deviceStatusForRow, deviceStatusLoading, plantId) => {
    if (deviceStatusLoading[plantId]) return <CircularProgress size={20} />
    const overallStatus = deviceStatusForRow?.overallDeviceStatus
    if (overallStatus === 'green') return <RadioButtonCheckedOutlinedIcon className="status-green" />
    else if (overallStatus === 'red') return <img src={Gridored} alt="GridOred" />
    else return <img src={Gridorange} alt="GridOrange" />
}

const renderGridStatusIcon = (deviceStatusForRow, deviceStatusLoading, plantId) => {
    if (deviceStatusLoading[plantId]) return <CircularProgress size={20} />
    const gridStatus = deviceStatusForRow?.gridStatus || 'offline'
    const overallStatus = deviceStatusForRow?.overallDeviceStatus
    if (overallStatus === 'green' && gridStatus === 'online') return <img src={Towerg} alt="Grid Online" />
    else if (overallStatus === 'yellow' && gridStatus === 'online') return <img src={Towery} alt="Grid Offline" />
    else return <img src={Towerred} alt="Grid Offline" />
}

function Row(props) {
    const {
        row,
        onClick,
        updateDeviceStatus,
        deviceStatus,
        deviceStatusLoading,
        issueCounts,
        handleViewIssues,
        isMonitoring,
        onBusinessClick,
    } = props
    const [open, setOpen] = React.useState(false)
    const [openInnerRow, setOpenInnerRow] = React.useState(false)

    useEffect(() => {
        if (row?.id) updateDeviceStatus(row.id)
    }, [row, updateDeviceStatus])

    const rowId = row?.plantId?.toString() || row?.id?.toString()
    const deviceStatusForRow = deviceStatus?.[rowId] || {}

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell onClick={(e) => e.shiftKey ? onBusinessClick() : onClick()}>
                    <div className="companylogo_bg"><img src={CompanyLogo} alt="company" /></div>
                </TableCell>
                <TableCell align="left" scope="row" onClick={(e) => e.shiftKey ? onBusinessClick() : onClick()}>{row?.plantName}</TableCell>
                {isMonitoring ? (
                    <TableCell align="left" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row?.projectCode}
                    </TableCell>
                ) : (
                    <TableCell align="center">
                        <span title={`${getDeviceInfoFromRoof(row?.roofDetails, 'dataLoggers').model}`}>
                            {getDeviceInfoFromRoof(row?.roofDetails, 'dataLoggers').make}
                        </span>
                    </TableCell>
                )}
                <TableCell align="left">{row?.plantLocation}</TableCell>
                <TableCell align="center">
                    <img src={SolarPanel} alt="solar" /> <b>{row?.plantSizeKW || 0}</b>
                </TableCell>
                {isMonitoring ? (
                    <>
                        <TableCell align="center">
                            <img src={Lighting} alt="light" />
                            <b>{row?.totalEToday !== null ? parseFloat(row?.totalEToday).toFixed(2) : 0}</b>
                        </TableCell>
                        <TableCell align="center" scope="row">
                            <b>{row?.dailyEnergy !== null ? parseFloat(row?.dailyEnergy).toFixed(2) : 0}</b>
                        </TableCell>
                        <TableCell align="center" scope="row">
                            <b>{row?.yield !== null ? parseFloat(row?.yield).toFixed(2) : 0}</b>
                        </TableCell>
                        <TableCell align="center"><b>{parseFloat(row?.gti).toFixed(2)}</b></TableCell>
                        <TableCell align="center"><b>{parseFloat(row?.PR).toFixed(2)}</b></TableCell>
                        <TableCell align="center"><b>{parseFloat(row?.CUF).toFixed(2)}</b></TableCell>
                        <TableCell align="center">{renderGridStatusIcon(deviceStatusForRow, deviceStatusLoading, row?.id)}</TableCell>
                        <TableCell align="center">
                            <div style={{ display: 'flex' }}>
                                <span className="device_status">{renderDeviceStatusIcon(deviceStatusForRow, deviceStatusLoading, row?.id)}</span>
                                <span className="device_status">
                                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                    </IconButton>
                                </span>
                            </div>
                        </TableCell>
                        <TableCell align="center">
                            <div
                                className={`issue_status ${issueCounts[row?.id] > 0 ? 'clickable' : ''}`}
                                onClick={() => issueCounts[row?.id] > 0 && handleViewIssues(row?.id, row?.plantName)}
                            >
                                {issueCounts[row?.id] > 0 ? <BugReportIcon className="issue_icon" /> : null}
                                <span className="issue_count">{issueCounts[row?.id] || 0}</span>
                            </div>
                        </TableCell>
                    </>
                ) : (
                    <>
                        <TableCell align="center">{row?.commissionDate ? new Date(row?.commissionDate).toLocaleDateString() : '-'}</TableCell>
                        <TableCell align="center">
                            <span title={`${getDeviceInfoFromRoof(row?.roofDetails, 'inverters').model}`}>{getDeviceInfoFromRoof(row?.roofDetails, 'inverters').make}</span>
                        </TableCell>
                        <TableCell align="center">
                            <span title={`${getDeviceInfoFromRoof(row?.roofDetails, 'energyMeters').model}`}>{getDeviceInfoFromRoof(row?.roofDetails, 'energyMeters').make}</span>
                        </TableCell>
                        <TableCell align="center">
                            <span title={`${getDeviceInfoFromRoof(row?.roofDetails, 'sensors').model}`}>{getDeviceInfoFromRoof(row?.roofDetails, 'sensors').make}</span>
                        </TableCell>
                        <TableCell align="center">
                            <div
                                className={`issue_status ${issueCounts[row?.id] > 0 ? 'clickable' : ''}`}
                                onClick={() => issueCounts[row?.id] > 0 && handleViewIssues(row?.id, row?.plantName)}
                            >
                                {issueCounts[row?.id] > 0 ? <BugReportIcon className="issue_icon" /> : null}
                                <span className="issue_count">{issueCounts[row?.id] || 0}</span>
                            </div>
                        </TableCell>
                    </>
                )}
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={isMonitoring ? 14 : 10}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <div className="align_btw">
                            <div className="align_end">
                                <div className="collapse_btn m_rl_8">
                                    <img src={Medical} alt="medical" /><span className="inr_txt">{deviceStatusForRow?.devices?.energyMeters || 0}</span>
                                </div>
                                <div className="collapse_btn m_rl_8">
                                    <img src={Multimeter} alt="multimeter" /><span className="inr_txt">{deviceStatusForRow?.devices?.inverters || 0}</span>
                                </div>
                                <div className="collapse_btn m_rl_8">
                                    <img src={Pyranometer} alt="pyranometer" /><span className="inr_txt">{deviceStatusForRow?.devices?.sensors || 0}</span>
                                </div>
                                <div className="collapse_btn m_rl_8">
                                    <img src={Accumulatordas} alt="accumulatordas" /><span className="inr_txt">{deviceStatusForRow?.devices?.dataLoggers || 0}</span>
                                </div>
                                <div className="m_rl_8">
                                    <IconButton aria-label="expand row" size="small" onClick={() => setOpenInnerRow(!openInnerRow)}>
                                        {openInnerRow ? <ExpandLess /> : <ExpandMore />}
                                    </IconButton>
                                </div>
                                <div className="m_rl_8 pointer" onClick={onClick}><FullscreenIcon /></div>
                            </div>
                        </div>
                        <Collapse in={openInnerRow} timeout="auto" unmountOnExit>
                            <TableContainer component={Paper} sx={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <Table aria-label="collapsible table" className="collapse_i_table">
                                    <TableHead sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                                        <TableRow>
                                            <TableCell align="left">Inverter Serial No.</TableCell>
                                            <TableCell align="left">Make/ Model</TableCell>
                                            <TableCell align="center">No. of strings</TableCell>
                                            <TableCell align="center">DC Loading(kW)</TableCell>
                                            <TableCell align="center">Daily Energy(kWh)</TableCell>
                                            <TableCell align="center">Total Energy(kWh)</TableCell>
                                            <TableCell align="center">Yield(kWh/kWp)</TableCell>
                                            <TableCell align="center">Status</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row?.roofDetails?.[0]?.inverters?.map((plData, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="left">{plData?.InverterSerialNumber}</TableCell>
                                                <TableCell align="left">{plData?.inverterMake || plData?.inverterMode}</TableCell>
                                                <TableCell align="center">{plData?.noOfStrings}</TableCell>
                                                <TableCell align="center">{plData?.dcCapacity}</TableCell>
                                                <TableCell align="center">{plData?.dailyEnergy}</TableCell>
                                                <TableCell align="center">{plData?.deviceTotalEnergy}</TableCell>
                                                <TableCell align="center">{parseFloat(plData?.dailyEnergy / row?.plantSizeKW).toFixed(1)}</TableCell>
                                                <TableCell align="center"><span className="device_status"><RadioButtonCheckedOutlinedIcon /></span></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Collapse>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}

const SolarPlantListDesktop = ({
    logic,
    permissions
}) => {
    const {
        currentRows,
        loading,
        isMonitoring,
        handleMonitoringToggle,
        searchName,
        handleSearch,
        sortDate,
        handleChangeDate,
        selectedValue,
        handleSelectChange,
        HandleSortPlant,
        deviceStatus,
        deviceStatusLoading,
        updateDeviceStatus,
        issueCounts,
        handleViewIssues,
        handleTechnicalView,
        handleAddnewplant,
        handleSolarMapView,
        handlePlantreport,
        currentPage,
        setCurrentPage,
        rowsPerPage,
        setRowsPerPage,
        headerRef,
        handleADDdevice,
        totalPlants,
        handleBusinessView
    } = logic

    const { is, can } = permissions
    const classes = useSolarPlantListStyles()

    // Locally calculate pagination info since the hook now does server-side pagination


    return (
        <div className={classes.root} id="solar_plant_list">
            <Box ref={headerRef} sx={{ '& .MuiTextField-root': { m: 1, width: '100%' } }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <div className="solar_search_button">
                            <div className="align_start" style={{ height: '48px' }}>
                                <div className="w80">
                                    <div className="searchbar">
                                        <TextField
                                            placeholder="Search..."
                                            onChange={handleSearch}
                                            value={searchName}
                                            InputProps={{
                                                disableUnderline: true,
                                                endAdornment: (
                                                    <InputAdornment position="start" className="pointer">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <div className="align_end wrap">
                            <div className="mr_8">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        format="DD-MM-YYYY"
                                        maxDate={dayjs()}
                                        value={sortDate}
                                        onChange={handleChangeDate}
                                    />
                                </LocalizationProvider>
                            </div>
                            {(is('Super Admin') || is('Admin') || is('Asset Management') || can('plant.create')) && (
                                <>
                                    <div className="monitoring_status_toggle">
                                        <label className="switch">
                                            <input type="checkbox" checked={isMonitoring} onChange={handleMonitoringToggle} />
                                            <span className="slider"></span>
                                        </label>
                                    </div>
                                    <div className="solar_list_h_button mr_8" onClick={handlePlantreport}>Reports</div>
                                </>
                            )}
                            {(is('Super Admin') || is('Admin') || is('Asset Management') || can('plant.create')) && (
                                <div className="solar_list_h_button mr_8" onClick={handleAddnewplant}>Add New Plant</div>
                            )}
                            {(is('Super Admin') || is('Admin') || is('Asset Management')) && (
                                <div className="solar_list_h_button mr_8" onClick={handleADDdevice}>Device List</div>
                            )}
                            <div>
                                <select className="selectbox mr_8" value={selectedValue} onChange={handleSelectChange}>
                                    <option value="">Plant Type</option>
                                    <option value="Capex">Capex</option>
                                    <option value="Opex">Opex</option>
                                </select>
                            </div>
                            {(is('Super Admin') || is('Admin') || is('Asset Management')) && (
                                <div className="map_list_toggle" onClick={handleSolarMapView}>
                                    <label className="switch"><input type="checkbox" /><span className="slider"></span></label>
                                </div>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </Box>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <TableContainer className="main_table" component={Paper} sx={{ height: 'auto', overflowY: 'auto' }}>
                        <Table aria-label="collapsible table">
                            <TableHead sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
                                <TableRow>
                                    <TableCell />
                                    <TableCell align="left">Plant Name</TableCell>
                                    <TableCell align="left">{isMonitoring ? 'Code' : 'Datalogger'}</TableCell>
                                    <TableCell align="left">Plant Location</TableCell>
                                    <TableCell align="center">
                                        Plant Size (kWp)
                                        <IconButton onClick={HandleSortPlant}><ImportExportIcon className="sort_i" /></IconButton>
                                    </TableCell>
                                    {isMonitoring ? (
                                        <>
                                            <TableCell align="center">Daily Energy (MFM)</TableCell>
                                            <TableCell align="center">E. Today (Inverter)</TableCell>
                                            <TableCell align="center">Yield (kWh/kWp)</TableCell>
                                            <TableCell align="center">GTI (kWh/m2)</TableCell>
                                            <TableCell align="center">PR (%)</TableCell>
                                            <TableCell align="center">CUF (%)</TableCell>
                                            <TableCell align="center">Grid Status</TableCell>
                                            <TableCell align="center">Device Status</TableCell>
                                            <TableCell align="center">Issues</TableCell>
                                        </>
                                    ) : (
                                        <>
                                            <TableCell align="center">Commission Date</TableCell>
                                            <TableCell align="center">Inverter</TableCell>
                                            <TableCell align="center">Energy Meter</TableCell>
                                            <TableCell align="center">Sensor</TableCell>
                                            <TableCell align="center">Issue</TableCell>
                                        </>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {currentRows?.map((row, index) => (
                                    <Row
                                        key={row.id || index}
                                        row={row}
                                        onClick={() => handleTechnicalView(row)}
                                        onBusinessClick={() => handleBusinessView(row)}
                                        updateDeviceStatus={updateDeviceStatus}
                                        deviceStatus={deviceStatus}
                                        deviceStatusLoading={deviceStatusLoading}
                                        issueCounts={issueCounts}
                                        handleViewIssues={handleViewIssues}
                                        isMonitoring={isMonitoring}
                                    />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 25, 50]}
                        component="div"
                        count={totalPlants}
                        rowsPerPage={rowsPerPage}
                        page={currentPage - 1}
                        onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
                        onRowsPerPageChange={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10))
                            setCurrentPage(1)
                        }}
                        sx={{
                            borderTop: '1px solid #e0e0e0',
                            '& .MuiTablePagination-toolbar': {
                                px: { xs: 1, sm: 2 },
                                minHeight: '52px',
                            },
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                fontSize: '0.875rem',
                                color: 'text.secondary',
                                mb: 0,
                            },
                            '& .MuiTablePagination-select': {
                                fontSize: '0.875rem',
                            },
                        }}
                    />
                </>
            )}
        </div>
    )
}

export default SolarPlantListDesktop
